import { DynamicSchema } from '@soniq/schema'

export type { UserSettingSchema } from '../../.types/UserSetting.schema'
import { definitions } from '../../.types/UserSetting.schema.json'
import { UserSettingSchema } from '../../.types/UserSetting.schema'
export const userSettingJsonSchema = {
  ...definitions.UserSettingSchema,
  definitions,
}
export const userSettingSchema =
  DynamicSchema.new<UserSettingSchema>({
    id: 'UserSettingSchema',
    jsonSchema: userSettingJsonSchema,
  })
export * from './guards'
export * from './types'
